import { ColorSpec } from "designSystem/components/colorchip/ColorChipArrayStore";
import { ColorChipArray, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import blackImage from "./Black.jpg";
import blueImage from "./Blue.jpg";
import greyImage from "./Grey.jpg";

export default () => {
	const defaultColor = {
		name: "No Image",
	};

	const colors: ColorSpec[] = [
		{
			name: "Blue",
			image: blueImage,
		},
		{
			name: "Black",
			image: blackImage,
		},
		{
			name: "Grey",
			image: greyImage,
		},
	];

	for (let i = 0; i < colors.length; i++) {
		colors[i].id = i.toString();
	}
	const colorsMax: ColorSpec[] = [
		{
			name: "Blue",
			image: blueImage,
		},
		{
			name: "Black",
			image: blackImage,
		},
		{
			name: "Grey",
			image: greyImage,
		},
		{
			name: "Blue2",
			image: blueImage,
		},
		{
			name: "Black2",
			image: blackImage,
		},
		{
			name: "Grey2",
			image: greyImage,
		},
	];
	for (let i = 0; i < colorsMax.length; i++) {
		colorsMax[i].id = i.toString();
	}

	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="no value" />
			<Text semiBold text="value" />
			<Text semiBold text="max" />
			<Text semiBold text="over max" />
			<ColorChipArray colors={colors} />
			<ColorChipArray colors={colors} value={colors[2]} />
			<ColorChipArray colors={colorsMax} />
			<ColorChipArray colors={colorsMax} defaultColor={defaultColor} />
		</CssColumnGrid>
	);
};